<template>
  <DialogPortal :disabled="!teleport">
    <DialogOverlay :class="overlayVariants({ type, variant, side })" />
    <DialogContent
      :class="
        contentVariants({
          type,
          variant,
          background,
          size,
          side,
          nested: !teleport,
        })
      "
      v-bind="ariaProps"
      :dir="useDirectionStore.getDirection"
      @pointerDownOutside="(e) => !dismissible && e.preventDefault()"
      @openAutoFocus="(event) => event.preventDefault()"
    >
      <Primitive v-if="$slots.header" id="header" asChild>
        <slot name="header" />
      </Primitive>
      <Transition name="slide-in">
        <Primitive
          v-if="withBackdropButton && delayAnimation && !maxTablet"
          @click="$emit('close')"
          class="absolute w-3 -left-3 hover:w-4 hover:-left-4 bg-utility-gray-300 flex rounded-none rounded-tl-xl rounded-tr-none transition-all cursor-pointer rounded-bl-xl rounded-br-none top-4 bottom-4 hover:top-3 hover:bottom-3"
        />
      </Transition>
      <div class="overflow-y-auto grow flex flex-col">
        <slot />
      </div>
      <Primitive v-if="$slots.footer" id="footer" asChild>
        <slot name="footer" />
      </Primitive>
    </DialogContent>
  </DialogPortal>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import {
  DialogContent,
  DialogOverlay,
  DialogPortal,
  Primitive,
} from "radix-vue";
import { overlayVariants, contentVariants } from ".";
import { directionStore } from "@/Stores/direction";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const useDirectionStore = directionStore();
const props = defineProps({
  variant: { type: String, required: false },
  background: { type: String, required: false },
  size: { type: [String, Number], required: false },
  side: { type: String, required: false },
  icon: { type: Boolean, required: false },
  teleport: { type: Boolean, default: true },
  dismissible: { type: Boolean, default: true },
  ariaProps: { type: Object, required: false },
  withBackdropButton: { type: Boolean, default: false },
});

// Breakpoints
const { maxTablet } = useBreakpoints();

const type = computed(() => (props.teleport ? "fixed" : "absolute"));
const delayAnimation = ref(false);

onMounted(() => {
  setTimeout(() => {
    delayAnimation.value = true;
  }, 300);
});
</script>

<style>
.slide-in-enter-active {
  transition: all 0.3s ease-out;
}
.slide-in-enter-from {
  width: 0rem;
  left: 0rem;
}

.slide-in-enter-to {
  width: 0.75rem;
  left: -0.75rem;
}
</style>
